export default {
  // Tab 标签
  transactionAnalysis: "交易分析",
  keyTransactions: "关键交易",
  counterparty: "交易对手(USDT)",
  transactionDetails: "主币转账",
  tokenTransfer: "代币转账",
  otherInfo: "其他信息",
  assets: "资产",

  // 统计信息
  total: "共计",
  totalData: "条数据",

  // 搜索和筛选
  searchCounterpartyAddress: "搜索交易对手地址",
  minAmount: "最小数量",
  maxAmount: "最大数量",
  minCount: "最少次数",
  maxCount: "最大次数",
  pleaseSelect: "请选择",
  pleaseSelectCurrency: "请选择币种",
  pleaseSelectCurrencyFirst: "请先选择币种",

  // 日期选择
  startDate: "开始日期",
  endDate: "结束日期",

  // 按钮
  reset: "重置",
  query: "查询",

  // 验证提示
  maxAmountError: "最大金额需≥最小金额",
  maxCountError: "最大次数需≥最小次数",

  // 选项
  senderReceiver: "发送方/接收方",
  sender: "发送方",
  receiver: "接收方",

  // 复选框
  hideZeroTransactions: "隐藏数量为0的交易",

  // 消息提示
  alreadyCurrentPage: "已经是当前地址详情页!",

  // 文件名
  dataDetailsFileName: "数据明细",
};
